import React from 'react';
import PropTypes from 'prop-types';
import { useAuthUser } from '@nbx/frontend-helpers/subscribe';
import Header from 'components/app/Header';
import Navigation from 'components/app/Navigation';
import { compareComplexProps } from 'helpers/memo';
import OVERLAYS from 'constants/overlays';

import { Context } from 'state/store';
import { setOverlay } from 'state/creators';
import { useIsMobile } from 'helpers/hooks';

const HeaderAndNavigation = props => {
  const [state, dispatch] = React.useContext(Context);
  const user = useAuthUser();
  const isMobile = useIsMobile();

  React.useEffect(() => {
    if (!user && state.activeOverlay === OVERLAYS.quickbuy) {
      dispatch(setOverlay(null));
    }
  }, [dispatch, user, state.activeOverlay]);

  const checkForClickOutsideMenu = React.useCallback(
    e => {
      if (state.menuToggleRef?.contains(e.target) || state.navToggleRef?.contains(e.target)) return;
      if (!state.menuRef?.contains(e.target) && !state.navRef?.contains(e.target)) {
        dispatch(setOverlay(null));
      }
    },
    [dispatch, state.menuToggleRef, state.navToggleRef, state.menuRef, state.navRef]
  );

  React.useEffect(() => {
    if ((state.overlay === OVERLAYS.menu && !state.switchingAccount) || state.overlay === OVERLAYS.nav)
      document.addEventListener('mousedown', checkForClickOutsideMenu);
    return () => document.removeEventListener('mousedown', checkForClickOutsideMenu);
  }, [state.overlay, state.switchingAccount, checkForClickOutsideMenu]);

  const isSideNavVisible = user !== null && !props.isLandingPage && !isMobile;

  return (
    <>
      <Header
        isLandingPage={props.isLandingPage}
        isTradingPage={props.isTradingPage}
        isMobile={props.isMobile}
        {...props.headerProps}
      />
      {isSideNavVisible && <Navigation isTradingPage={props.isTradingPage} />}
    </>
  );
};

HeaderAndNavigation.propTypes = {
  headerProps: PropTypes.object.isRequired,
  isLandingPage: PropTypes.bool.isRequired,
  isTradingPage: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export default React.memo(HeaderAndNavigation, compareComplexProps);
